import ProductGridItem from '../components/ProductGridItem';
import Modal from '../components/Modal';

import { removeTrapFocus, trapFocus } from '#helpers';

export default class StaticCollection {
  constructor(section) {
    this.section = section;
    this.$el = $(section.el);
    this.sortWidth = null;
    this.$focusItem = null;
    this.sortContent = '[data-productgrid-sort-content]';
    this.$sortOpen = this.$el.find('[data-productgrid-sort-open]');
    this.$sortTrigger = this.$el.find('[data-productgrid-trigger-sort]');
    this.$sortTriggerButton = this.$el.find(
      '[data-productgrid-trigger-sort-button]'
    );
    this.$sortTriggerModal = this.$el.find('[data-productgrid-modal-sort]');
    this.$sortOptions = this.$el.find('[data-productgrid-sort-options]');
    this.$gridViewToggle = this.$el.find('[data-collection-grid-view]');
    this.$listViewToggle = this.$el.find('[data-collection-list-view]');
    this.$gridContainer = this.$el.find('[data-product-grid-wrapper]');

    this._openSorting = this._openSorting.bind(this);
    this._changeSorting = this._changeSorting.bind(this);
    this._changeSortingButton = this._changeSortingButton.bind(this);
    this._showSortModal = this._showSortModal.bind(this);

    this._onModalOpen = this._onModalOpen.bind(this);
    this._onModalClose = this._onModalClose.bind(this);

    this._toggleListView = this._toggleListView.bind(this);
    this._toggleGridView = this._toggleGridView.bind(this);
    this._checkListView = this._checkListView.bind(this);

    const modalCallbacks = {
      onOpen: this._onModalOpen,
      onClose: this._onModalClose
    };

    this.events = [
      this.$sortOpen.on('click.collection', this._openSorting),
      this.$sortOptions.on('click.collection', 'a', event => {
        event.preventDefault();
        this._triggerChangeSorting(event.currentTarget);
      }),
      this.$sortTrigger.on('change.collection', this._changeSorting),
      this.$sortTriggerButton.on('click.collection', this._changeSortingButton),
      this.$sortTriggerModal.on('click.collection', this._showSortModal),
      this.$gridViewToggle.on('click.collection', this._toggleGridView),
      this.$listViewToggle.on('click.collection', this._toggleListView),
      $(document).on('touchstart.collection, click.collection', event => {
        this._handleDocumentClick(event.target);
      })
    ];

    // Product items
    this.productItems = [];
    const $productItems = this.$el.find('[data-product-item]');

    $productItems.each((i, productItem) => {
      this.productItems.push(new ProductGridItem($(productItem)));
    });

    this._setSortByQueryParameters();
    this.modal = new Modal(modalCallbacks);
  }

  onSectionUnload() {
    this.events.forEach($el => $el.off('.collection'));
    this.modal.unload();

    if (this.sortWidth) {
      this.sortWidth.unload();
    }

    this.productItems.forEach(productItem => {
      productItem.unload();
    });
  }

  /**
   * Open Sort by modal (on mobile)
   *
   * @param event
   * @private
   */
  _showSortModal(event) {
    event.preventDefault();

    this.$focusItem = $(event.currentTarget);
    this.modal.open(this.sortContent, 'productgrid-sort');
  }

  /**
   * Make Shopify aware of releavent collection search info
   *  - tag
   *  - vendor
   *  - pagination
   *  - sorting criteria
   *
   * @private
   */
  _setSortByQueryParameters() {
    Shopify.queryParams = {};
    if (location.search.length) {
      for (
        let i = 0, aCouples = location.search.substr(1).split('&');
        i < aCouples.length;
        i++
      ) {
        const aKeyValue = aCouples[i].split('=');
        // Reset the page number when we apply (i.e. don't add it to params)
        if (aKeyValue.length > 1 && aKeyValue[0] !== 'page') {
          Shopify.queryParams[
            decodeURIComponent(aKeyValue[0])
          ] = decodeURIComponent(aKeyValue[1]);
        }
      }
    }

    this._checkListView();
  }

  /**
   * Sort by opens a modal on mobile, this handles button events
   *
   * @param event
   * @private
   */
  _changeSortingButton(event) {
    const activeClass = 'utils-sortby--modal-button--active';

    $(event.currentTarget)
      .addClass(activeClass)
      .parent()
      .siblings()
      .find(`.${activeClass}`)
      .removeClass(activeClass);

    this._changeSorting(event);
  }

  _handleDocumentClick(target) {
    const $parent = $(target).closest('[data-productgrid-sort-custom]');
    if ($parent.length) {
      return;
    }

    this.$sortOptions.revealer('hide');
  }

  /**
   * Open custom collection sorting select
   *
   * @param event
   * @private
   */
  _openSorting() {
    this.$sortOptions.revealer('show');
  }

  _triggerChangeSorting(target) {
    const $target = $(target);
    const value = $target.data('productgrid-sort-value');

    this._changeSorting(null, value);
  }

  /**
   * Change sorting of collection
   *
   * @param event
   * @private
   */
  _changeSorting(event, value) {
    let $target;

    if (event) {
      event.preventDefault();
      $target = $(event.currentTarget);
    }

    const newSort = event ? $target.val() : value;

    Shopify.queryParams.sort_by = newSort;
    location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, '%20');
  }

  /**
   * When a modal is open, move focus into the modal for a11y
   *
   * @private
   */
  _onModalOpen() {
    trapFocus({
      $container: this.modal.$modal,
      namespace: 'productgrid-modal'
    });
  }

  /**
   * Return focus to last used button (if found) on modal close
   *
   * @private
   */
  _onModalClose() {
    removeTrapFocus({
      $container: this.modal.$modal,
      namespace: 'productgrid-modal'
    });

    if (this.$focusItem) {
      this.$focusItem.focus();
      this.$focusItem = null;
    }
  }

  /**
   * Toggle grid view
   *
   */
  _toggleGridView(event) {
    Shopify.queryParams.grid_list = 'grid-view';
    location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, '%20');
  }

  /**
   * Toggle list view
   *
   */
  _toggleListView(event) {
    Shopify.queryParams.grid_list = 'list-view';
    location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, '%20');
  }

  /**
   * Check grid/list view toggle query parameters
   *
   */
  _checkListView() {
    if (Shopify.queryParams.grid_list === 'list-view') {
      this.$el.find('[href*="&grid_list"]').attr('href', (i, href) => {
        if (href.indexOf('?') === -1) {
          href = href.replace('&', '?');
        }

        return href.replace('grid_list', 'grid_list=list-view');
      });

      this.$el.find('.utils-viewtoggle-button').removeClass('active');
      this.$listViewToggle.addClass('active');
      this.$gridContainer.addClass('productgrid-listview');
    } else {
      this.$el.find('[href*="&grid_list"]').attr('href', (i, href) => {
        if (href.indexOf('?') === -1) {
          href = href.replace('&', '?');
        }

        return href.replace('grid_list', 'grid_list=grid-view');
      });
    }
  }
}
